import Reveal from '../components/ui/Reveal';
import { Section, SectionHeading } from '../components/ui/Section';

const STEPS = [
    {
        number: '01',
        title: 'Choisissez votre forfait',
        description:
            "Sélectionnez la durée et le nombre d'écrans qui vous conviennent, puis réglez en une fois par carte, PayPal, Bancontact ou crypto.",
        icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
    },
    {
        number: '02',
        title: 'Recevez vos accès par e-mail',
        description:
            "Vos codes Xtream, votre lien M3U et le guide d'installation vous sont envoyés sous 5 à 15 minutes après validation du paiement.",
        icon: 'M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    },
    {
        number: '03',
        title: 'Installez et regardez',
        description:
            "Ouvrez IPTV Smarters, TiviMate ou IBO Pro sur votre appareil, saisissez vos identifiants et accédez immédiatement au catalogue complet.",
        icon: 'M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    },
];

export default function How() {
    return (
        <Section id="installation" className="border-y border-line bg-ink-900/40">
            <SectionHeading
                eyebrow="Installation"
                title="Opérationnel en trois étapes"
                description="Aucune compétence technique requise. La plupart de nos clients regardent leur première chaîne moins de vingt minutes après la commande."
            />

            <ol className="relative grid gap-5 md:grid-cols-3">
                {/* Connector line, desktop only. */}
                <li
                    aria-hidden="true"
                    className="pointer-events-none absolute left-0 right-0 top-[3.25rem] hidden h-px bg-gradient-to-r from-transparent via-line-strong to-transparent md:block"
                />

                {STEPS.map((step, index) => (
                    <Reveal as="li" key={step.number} delay={index * 100} className="relative">
                        <div className="flex h-full flex-col rounded-2xl border border-line bg-surface-raised/60 p-7 transition-[transform,border-color] duration-300 ease-smooth hover:-translate-y-1 hover:border-line-strong">
                            <div className="mb-6 flex items-center gap-4">
                                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-brand text-ink-950">
                                    <svg
                                        className="h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        aria-hidden="true"
                                    >
                                        <path d={step.icon} />
                                    </svg>
                                </span>
                                <span className="text-3xl font-extrabold tracking-tight text-white/[0.14]">
                                    {step.number}
                                </span>
                            </div>

                            <h3 className="text-title font-bold text-white">{step.title}</h3>
                            <p className="mt-3 leading-relaxed text-content-muted text-pretty">
                                {step.description}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </ol>
        </Section>
    );
}
